export default "__VITE_ASSET__CmOMEWOz__"